import { IDataTableColumn } from "nsitools-react";
import * as React from "react";
import { useHistory } from "react-router";
import styled from "styled-components";

import { EntiteCentreApi, EntiteCentreSearch, FcbEntitecentreDto, EBooleanSearchTypes } from "../../../../../api";
import { ERoutes } from "../../../../../AppRouter";
import { SearchTablePage, EditButton, ViewButton } from "../../../../../components";
import { useTl } from "../../../../../hooks";
import { useAbortableApiServiceFactory, useApiService } from "../../../../../hooks/useApiService";
import { ETLCodes } from "../../../../../locales";

interface ICentreGlobalListPageProps {}
const Container = styled.div`
  display: flex;
`;
export const CentreGlobalListPage: React.FunctionComponent<ICentreGlobalListPageProps> = () => {
  const { t } = useTl();
  const history = useHistory();
  const api = useApiService(EntiteCentreApi);

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        computed: true,
        fieldName: "actions",
        autoFitContent: true,
        render: (row: FcbEntitecentreDto) => (
          <Container>
            <ViewButton
              minimal={true}
              onClick={() => history.push(`${ERoutes.centreGlobal}/${row.identite}/detail/view`)}
            />
            <EditButton
              minimal={true}
              onClick={() => history.push(`${ERoutes.centreGlobal}/${row.identite}/detail/edit`)}
            />
          </Container>
        )
      },
      {
        header: () => t(ETLCodes.Nom),
        fieldName: "nom"
      }
    ],
    [history, t]
  );

  const addItemFunction = React.useCallback(() => history.push(`${ERoutes.centreGlobal}/0/detail/edit`), [history]);

  const getCriteriasFn = React.useCallback(() => api.entiteCentreGetSearchCriterias({ includeListsValues: true }), [
    api
  ]);

  const apiFactory = useAbortableApiServiceFactory(EntiteCentreApi);
  const lastAbortController = React.useRef<AbortController>();
  const searchFn = React.useCallback(
    (nextSearch?: EntiteCentreSearch) => {
      const { api: abortableApi, abortController } = apiFactory();
      lastAbortController.current = abortController;
      return abortableApi.entiteCentreBaseSearch({ EntiteCentreSearch: nextSearch });
    },
    [apiFactory]
  );

  const onAbort = React.useCallback(() => lastAbortController.current?.abort(), []);

  return (
    <SearchTablePage
      columns={columns}
      getCriteriasFunction={getCriteriasFn}
      searchFunction={searchFn}
      onAbort={onAbort}
      addFunc={addItemFunction}
      breadCrumbs={[{ text: t(ETLCodes.CentreGlobal) }]}
      sortKeys={{ nom: "ASC" }}
      defaultCriterias={[
        {
          criteria: "Actif",
          searchMode: EBooleanSearchTypes.Equals,
          value: true
        }
      ]}
    />
  );
};
